import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=c0adf344&"
import script from "./ChatContent.vue?vue&type=script&lang=js&"
export * from "./ChatContent.vue?vue&type=script&lang=js&"
import style0 from "./ChatContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0adf344')) {
      api.createRecord('c0adf344', component.options)
    } else {
      api.reload('c0adf344', component.options)
    }
    module.hot.accept("./ChatContent.vue?vue&type=template&id=c0adf344&", function () {
      api.rerender('c0adf344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/newChat/ChatContent.vue"
export default component.exports